import { useEffect } from 'react'

import { Common } from 'src/core/imgStore'

import styles from './SiteUpdateLayout.module.scss'

const UPDATE_CHECK_INTERVAL = 1000 * 60 // 1min

export const SiteUpdateLayout = () => {
  useEffect(() => {
    setTimeout(() => window.location.reload(), UPDATE_CHECK_INTERVAL)
  }, [])

  return (
    <div className={styles.root}>
      <div className={styles.centering}>
        <div className={styles.content}>
          <img className={styles.logo} src={Common['hp-logo']} alt="HP" />
          <div className={styles.body}>
            <p className={styles.title}>Down for Maintenance</p>
            <p>Dear Valued Visitors,</p>
            <p>
              We would like to inform you that our website will be temporarily unavailable due to
              scheduled maintenance. This is necessary to ensure optimal performance and enhance
              your user experience.
            </p>
            <p>
              Please note that the website will be inaccessible now. We will be working diligently
              to perform updates and improvements.
            </p>
            <p>
              We apologize for any inconvenience this may cause and appreciate your patience and
              understanding. We encourage you to check back after the maintenance window to enjoy
              the enhancements we've made.
            </p>
            <p>Thank you for your continued support.</p>
            <p className={styles.closing}>Best regards.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SiteUpdateLayout
